import React, { useEffect, useState } from "react";
import Product from "./Product";
import Sidebar from "./Sidebar";
import styles from "../../css/dm.module.css";
import Dealers from "./Dealers";
import Machine from "./Machine";
import RoleManagement from "./RoleManagement";
import DirectDebitDealers from "./DirectDebitDealers";
import { useTranslation } from "../../common/translation-context";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Banner from "../../common/Banner";
import { useSelector } from "react-redux";
import { getUserRole } from "../../utils/utils";
import { ROLES, QUERY_PARAMS } from "../../constants/constant";

const DataManagement = () => {
  const { translate: t } = useTranslation();
  const location = useLocation();
  const { state } = location;
  const userData = useSelector((state) => state.userState.userData);
  const [showProduct, setShowProduct] = useState(false);
  const [showDealers, setShowDealers] = useState(true);
  const [showMachine, setShowMachine] = useState(false);
  const[showRoleManagement, setShowRoleManagement] = useState(false);
  const [showDirectDebitDealers, setShowDirectDebitDealers] = useState(false);

  // Check if user can access Direct Debit Dealers
  const canAccessDirectDebitDealers =
    getUserRole(userData) === ROLES.BP ||
    (getUserRole(userData) === ROLES.CCM && userData?.country === "JD");

  const handleProductClick = () => {
    setShowProduct(true);
    setShowDealers(false);
    setShowMachine(false);
    setShowRoleManagement(false);
    setShowDirectDebitDealers(false);
  };

  const handleDealersClick = () => {
    setShowProduct(false);
    setShowDealers(true);
    setShowMachine(false);
    setShowRoleManagement(false);
    setShowDirectDebitDealers(false);
  };

  const handleMachineClick = () => {
    setShowMachine(true);
    setShowProduct(false);
    setShowDealers(false);
    setShowRoleManagement(false);
    setShowDirectDebitDealers(false);
  };

  const handleRoleManagementClick = () => {
    setShowRoleManagement(true);
    setShowMachine(false);
    setShowProduct(false);
    setShowDealers(false);
    setShowDirectDebitDealers(false);
  };

  const handleDirectDebitDealersClick = () => {
    // Only allow access if user has permission
    if (!canAccessDirectDebitDealers) {
      return;
    }
    setShowDirectDebitDealers(true);
    setShowProduct(false);
    setShowDealers(false);
    setShowMachine(false);
    setShowRoleManagement(false);
  }; 

  useEffect(() => {
    // Check URL query parameters for autoAdd functionality
    const searchParams = new URLSearchParams(location.search);
    const baseCode = searchParams.get(QUERY_PARAMS.BASE_CODE);
    const autoAdd = searchParams.get(QUERY_PARAMS.AUTO_ADD);
    const isProduct = searchParams.get(QUERY_PARAMS.IS_PRODUCT);
    
    if (baseCode && autoAdd === 'true' && isProduct === 'true') {
      // Automatically show product tab when redirected from errors tab
      setShowProduct(true);
      setShowDealers(false);
      setShowMachine(false);
      setShowRoleManagement(false);
      setShowDirectDebitDealers(false);
    } else if (state?.isProduct) {
      setShowProduct(true);
      setShowDealers(false);
      setShowMachine(false);
      setShowRoleManagement(false);
      setShowDirectDebitDealers(false);
    }
  }, [state, location.search]);

  return (
    <div>
      <div>
      {showDirectDebitDealers && canAccessDirectDebitDealers && (
        <Banner
          bannerMsg="Setting a customer number on the list of dealers on direct debit will affect the Interest Bearing calculation starting from the next fiscal month"
        />
      )}
      </div>

      <div>
        <h2>{t("dataManagement")}</h2>
      </div>
      <div className={styles.container}>
        <div className={styles.sidebar}>
          <Sidebar
            state={state}
            handleProductClick={handleProductClick}
            handleDealersClick={handleDealersClick}
            handleMachineClick={handleMachineClick}
            handleRoleManagementClick={handleRoleManagementClick}
            handleDirectDebitDealersClick={handleDirectDebitDealersClick}
          />
        </div>
        <div className={styles.product}>
          {showProduct && <Product newBaseCode={state?.newBaseCode || new URLSearchParams(location.search).get(QUERY_PARAMS.BASE_CODE)} />}
          {showDealers && <Dealers />}
          {showMachine && <Machine />}
          {showRoleManagement && <RoleManagement />}
          {showDirectDebitDealers && canAccessDirectDebitDealers && <DirectDebitDealers />}
        </div>
      </div>
    </div>
  );
};

export default DataManagement;
